import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChapterHeading } from "./ChapterHeading";
import { useLang } from "../lib/i18n";

const TAB_KEYS = ["Service Levels", "Technology & Cloud", "Security", "Commercial Models", "Roadmap", "Launch Plan", "Roles & Risks"];
const TAB_AR = {
  "Service Levels": "مستويات الخدمة", "Technology & Cloud": "التقنية والسحابة", "Security": "الأمان",
  "Commercial Models": "النماذج التجارية", "Roadmap": "خارطة الطريق", "Launch Plan": "خطة الإطلاق",
  "Roles & Risks": "الأدوار والمخاطر"
};

export const Handover = () => {
  const [tab, setTab] = useState(TAB_KEYS[0]);
  const { t, lang } = useLang();
  const tabs = t("handover.tabs");
  const c = tabs[tab];

  return (
    <section id="handover" data-testid="handover-section" className="bg-ink py-28 md:py-40 grain relative">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 relative z-10">
        <ChapterHeading number="04" title={t("handover.title")} dark />

        <div className="grid lg:grid-cols-[280px_1fr] gap-10 lg:gap-20">
          <div data-testid="handover-tabs" role="tablist" aria-label="Handover topics"
            className="flex lg:flex-col gap-1 overflow-x-auto lg:overflow-visible border-b lg:border-b-0 lg:border-s border-gold/20">
            {TAB_KEYS.map((k) => (
              <button key={k} role="tab" aria-selected={tab === k} data-testid={`handover-tab-${k.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                onClick={() => setTab(k)}
                className={`text-start whitespace-nowrap px-5 py-4 text-[11px] tracking-[0.25em] uppercase border-s-2 transition-colors duration-300 ${
                  tab === k ? "border-gold text-gold bg-gold/5" : "border-transparent text-cream/45 hover:text-cream"
                }`}>
                {lang === "ar" ? TAB_AR[k] : k}
              </button>
            ))}
          </div>

          <AnimatePresence mode="wait">
            <motion.div key={tab + lang} data-testid="handover-content" role="tabpanel"
              initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -12 }}
              transition={{ duration: 0.45, ease: "easeOut" }}
              className="min-h-[320px]">
              <p className="font-display text-2xl md:text-3xl text-cream leading-relaxed max-w-2xl">{c.intro}</p>
              <div className="mt-10 space-y-px bg-gold/15 border border-gold/15">
                {c.points.map(([k, v]) => (
                  <div key={k} className="bg-ink p-6 md:p-7 grid sm:grid-cols-[180px_1fr] gap-2 sm:gap-8">
                    <span className="text-[11px] tracking-[0.3em] uppercase text-gold">{k}</span>
                    <span className="text-sm text-cream/70 leading-relaxed">{v}</span>
                  </div>
                ))}
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
};
